import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getHashtagAISummary } from '@opm/services';
import { useEffect, useState } from 'react';

export interface IHashtagAISummaryFilter {
  hashtag?: string;
  time_range?: string;
  start_time?: string;
  end_time?: string;
}

export interface IHashtagAISummaryData {
  summary_zh?: string;
  summary_en?: string;
  update_date?: string;
}

export function useHashtagAISummary({
  filter,
}: {
  filter?: IHashtagAISummaryFilter;
}) {
  const [data, setData] = useState<IHashtagAISummaryData | null>(null);
  const { wrapperCancelRequest, loading } = useCancelRequestHook();

  function request() {
    if (!filter?.hashtag) return;
    wrapperCancelRequest(getHashtagAISummary, filter)
      .then(res => {
        setData((res as IHashtagAISummaryData) || null);
      })
      .catch(() => {
        setData(null);
      });
  }

  useEffect(() => {
    if (filter?.hashtag) {
      request();
    }
  }, [filter]);

  return {
    data,
    loading,
  };
}
